import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Bot } from "lucide-react";

interface AIAssistantAvatarProps {
  name?: string;
  company?: string;
  avatarUrl?: string | null;
  size?: "sm" | "md" | "lg";
  showInfo?: boolean;
}

export const AIAssistantAvatar = ({ 
  name = "Assistente de IA",
  company,
  avatarUrl,
  size = "md",
  showInfo = true
}: AIAssistantAvatarProps) => {
  const sizeClasses = {
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-16 w-16"
  };

  const iconSizes = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-8 w-8"
  };

  return (
    <div className="flex items-center gap-3">
      <Avatar className={sizeClasses[size]}>
        <AvatarImage src={avatarUrl || undefined} alt={name} />
        <AvatarFallback>
          <Bot className={iconSizes[size]} />
        </AvatarFallback>
      </Avatar>
      
      {showInfo && (
        <div className="flex flex-col">
          <span className="font-medium text-sm">{name}</span>
          {company && (
            <span className="text-xs text-muted-foreground">{company}</span>
          )}
        </div>
      )}
    </div>
  );
};
